(function () {
  // 1) N'agir qu'en français
  var isFR = (document.documentElement.lang || '').toLowerCase().startsWith('fr');
  if (!isFR) return;

  // 2) Traductions ciblées
  function translate(scope) {
    var root = scope || document;

    root.querySelectorAll('.appstle_subscribe_save_text').forEach(function (el) {
      if (!el.dataset.i18nDone) {
        el.textContent = "S'abonner et économiser";
        el.dataset.i18nDone = '1';
      }
    });

    root.querySelectorAll('.appstle_one_time_text').forEach(function (el) {
      if (!el.dataset.i18nDone) {
        el.textContent = "Achat unique";
        el.dataset.i18nDone = '1';
      }
    });
  }

  // 3) Au chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ translate(); });
  } else {
    translate();
  }

  // 4) Et si Appstle re-render le widget
  var obs = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return; // ELEMENT_NODE
        if (node.matches && node.matches('.appstle_subscribe_save_text, .appstle_one_time_text')) translate(node);
        if (node.querySelector) translate(node);
      });
    });
  });
  obs.observe(document.body, { childList: true, subtree: true });
})();